// Unpublished Work © 2020-2026 Deere & Company.

import t from 'tcomb';

export const BusinessActivities = t.struct({
    canAddEdit: t.Boolean,
    canMerge: t.Boolean,
    canRetrieveDBSCustomerDetails: t.maybe(t.Boolean),
    canSearchByTaxIdOnly: t.Boolean,
    canRetrieveDigitalUserDetails: t.maybe(t.Boolean)
}, {
    defaultProps: {
        canAddEdit: true,
        canMerge: true,
        canRetrieveDBSCustomerDetails: null,
        canSearchByTaxIdOnly: false,
        canRetrieveDigitalUserDetails: null
    },
    name: 'BusinessActivities',
    strict: true
});
